/*
 * Copyright (c) 2023. Collabro Limited
 */
import React, { useContext, useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import { AuthenticatedContext } from "../Authenticated/Authenticated";
import ClearIcon from "@mui/icons-material/Clear";

interface QuickSearchProps {
  containerWidth: number | null;
  variant: "filled" | "standard" | "outlined" | undefined;
}

const QuickSearch = (props: QuickSearchProps) => {
  const { searchQuery, setSearchQuery } = useContext(AuthenticatedContext);
  const [localSearchQuery, setLocalSearchQuery] = useState(searchQuery);

  const sendSearchQuery = () => {
    setSearchQuery(localSearchQuery);
  };
  const handleChange = (e: any) => {
    setLocalSearchQuery(e.target.value);
  };

  const handleClear = () => {
    setSearchQuery("");
  };

  return (
    <div
      style={{
        width: props.containerWidth ? `${props.containerWidth}px` : "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      <TextField
        label="Search"
        size="small"
        fullWidth
        variant={props.variant}
        autoFocus
        onChange={handleChange}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            sendSearchQuery();
          }
        }}
        value={localSearchQuery}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={sendSearchQuery} edge="end">
                <ArrowCircleUpIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <IconButton
        edge="start"
        sx={{
          ml: 1,
        }}
        onClick={handleClear}
      >
        <ClearIcon fontSize="small" />
      </IconButton>
    </div>
  );
};

export default QuickSearch;
